import { useState } from 'react';
import styles from './index.module.sass';
import Dialog from 'components/dialog';
import { getLoginState } from 'model/user';
import { useAppContext } from 'use-app';
import amplitude from 'service/amplitude';
import { ReactComponent as Arrow } from 'assets/notification_arrow.svg';
import { colorDetect } from 'helpers/color-detect';

const Notification = () => {
  const { state: appState } = useAppContext();
  let notification = appState.mainPageNotificationBoard;
  const loginState = getLoginState();
  const isUser = loginState === 'user';
  notification = isUser ? notification : notification.filter(p => !p.action.needLogin);
  const [dialogShow, setDialogShow] = useState(false);
  const [dialogContent, setDialogContent] = useState({});

  if (!notification || notification.length === 0) return <></>;

  return (
    <>
      <Dialog
        isShow={dialogShow}
        image={dialogContent.image}
        title={dialogContent.title}
        message={dialogContent.message}
        button={dialogContent.positiveButton}
        onConfirm={() => setDialogShow(false)}
        onDismiss={() => setDialogShow(false)}
      />
      <div
        className={styles.notification}
        style={{
          background: notification[0].attributes.backgroundColor,
          color: notification[0].attributes.contentColor,
        }}
        onClick={() => {
          if (notification[0].action.messageBox) {
            setDialogShow(true);
            setDialogContent(notification[0].action.messageBox);
            amplitude.main_notification_onClick(notification[0].id);
          }
        }}
      >
        {notification[0].attributes.content}
        {notification[0].action.messageBox && (
          <Arrow
            className={colorDetect(notification[0].attributes.backgroundColor) === 'dark' ? styles.light : styles.dark}
          />
        )}
      </div>
    </>
  );
};

export default Notification;
